exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.conver {\n    border: 1px solid;\n    border-radius: 8px;\n    padding: 5px;\n}\n.right {\n    text-align: right;\n    background: rgb(147 235 169);\n}\n", ""]);

// exports
